export var isDateInRange = function isDateInRange(date, dateFrom, dateTo) {
  return date.valueOf() >= dateFrom.valueOf() && date.valueOf() <= dateTo.valueOf();
};